import styled from "@emotion/styled";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Link from "next/link";

const FooterContainer = styled.footer`
  color: var(--color-background);
  background-color: var(--color-primary);
  padding: 1rem;

  a {
    color: var(--color-background);
  }

  svg {
    max-width: 15rem;
    width: 100%;
    height: auto;
  }

  ul {
    list-style: none;
    padding: 0;

    margin-top: 0.5rem;
  }
`;

const Footer = () => (
  <FooterContainer>
    <Container>
      <Row>
        <Col xs={12} md={10} />
        <Col xs={12} md={2}>
          <ul>
            <li>
              <Link href="/privacy-policy">
                <FormattedMessage id="Footer.privacyPolicy" defaultMessage="Privacy Policy" />
              </Link>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  </FooterContainer>
);

export default Footer;
